export const RouteConstants = {
  BASE: "/",
  LOGIN: "/login",
  OKTA: "/okta"
};
